import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Container, Card, Button } from 'react-bootstrap';

const Unauthorized = () => {
  const { user, logout } = useAuth();

  const getRedirectPath = () => {
    switch (user?.role) {
      case 'super_admin':
        return '/super-admin/dashboard';
      case 'site_admin':
        return '/site-admin/dashboard';
      default:
        return '/login';
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Card className="text-center p-4 shadow" style={{ maxWidth: '400px', width: '100%' }}>
        <Card.Body>
          <div className="mb-4">
            <i className="fas fa-ban text-danger" style={{ fontSize: '3rem' }}></i>
          </div>
          <h3 className="mb-3">Access Denied</h3>
          <p className="text-muted mb-4">
            You don't have permission to access this page. 
            Your current role is: <strong>{user?.role}</strong>
          </p>
          <div className="d-grid gap-2">
            <Button as={Link} to={getRedirectPath()} variant="primary">
              Go to Your Dashboard
            </Button>
            <Button variant="outline-secondary" onClick={logout}>
              Switch Account
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Unauthorized;